export const segmentArray = n => arr => arr.reduce((r,e,i) => i%n ? (r[r.length-1].push(e), r) : (r.push([e]), r), []);
export const arrayCols = n => xs => segmentArray(Math.ceil(xs.length / n))(xs);
export const toArray = (obj) => Object.keys(obj).map((key) => obj[key]);
export const isObjectEmpty = (obj) => Object.getOwnPropertyNames(obj).length === 0;
export const ObjectLength = (obj) => Object.getOwnPropertyNames(obj).length;
export const weekdayNames = ['Sun','Mon','Tues','Wed','Thur','Fri','Sat'];
export const arrayCounter = (data) => data.reduce((acc, number) => acc + parseInt(number), 0);
export const getTotalForItem = (data, item) => data.reduce((acc, itemRec) => acc + parseInt(itemRec[item]), 0);
export const toTime = (timestamp) => (timestamp > 120000)?(timestamp > 7200000)? Math.round(timestamp/3600000):Math.round(timestamp/60000):Math.round(timestamp/1000);
//export const toTime = (timestamp) => (timestamp > 120000)?(timestamp > 7200000)? Math.floor(timestamp/3600000):Math.floor(timestamp/60000):Math.floor(timestamp/1000);
export const toTimeType = (timestamp) => (timestamp > 120000)?(timestamp > 7200000)?'Hours':'Mins':'Secs';
export const upperClamp = (max) => (val) => Math.min(max, val); 

export const removeDuplicates=(myArr, prop)=>{
  return myArr.filter((obj, pos, arr) => {
      return arr.map(mapObj => mapObj[prop]).indexOf(obj[prop]) === pos;
  });
};

export const removeArrayDuplicates =(values)=>values.filter((val,id,array) => array.indexOf(val) == id);
export const padArray = (arr,len,fill) => arr.concat(Array(len).fill(fill)).slice(0,len);

export const getBit=(number, offset)=>{
  var bitmask = 1 << offset;
  if ((number & bitmask) != 0) return 1; else return 0;
};   

export const timeConverter = (timestamp) =>{
  var a = new Date(timestamp);
  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var year = a.getFullYear();
  var month = months[a.getMonth()];
  var date = a.getDate();
  var hour = a.getHours();
  var min = a.getMinutes();
  var sec = a.getSeconds();
  var time =  ' ' + month + ' ' + date +' '+ year;
  return time;
};

export const timeOfDayConverter = (timestamp) =>{
  var a = new Date(timestamp); 
  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var year = a.getFullYear();
  var month = months[a.getMonth()];
  var date = a.getDate();
  var hour = a.getHours();
  var min = a.getMinutes();
  var sec = a.getSeconds();
  var time =  ' ' + month + ' ' + date +' '+ year+' (' + hour + ':' + (min+'').padStart(2, '0') +':'+ (sec+'').padStart(2, '0')+')';
  return time;
};

export const timeConverterMonthYear = (timestamp) =>{
  var a = new Date(timestamp);
  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var year = a.getFullYear();
  var month = months[a.getMonth()];
  var time =  ' ' + month + ' '+ year;
  return time;
};

export const timeConverterChart = (timestamp) =>{
  var a = new Date(timestamp);
  var year = a.getFullYear();
  var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var month = months[a.getMonth()];
  var date = a.getDate();
  var time = month + ' ' + date.toString().padStart(2,'0') ;
  return time;
};

export const timeConverterSM = (timestamp) =>{
  var a = new Date(timestamp);
  var year = a.getFullYear();
  var month = a.getMonth()+1;
  var date = a.getDate();
  var time =  year +'-' + month.toString().padStart(2,'0') + '-' + date.toString().padStart(2,'0') ;
  return time;
};

export const dateMinusDays = (milliDate, minusDays) =>{
  let startDate = new Date(milliDate);
  startDate.setHours(0,0,0,0);
  let endDate = new Date(startDate.getTime() - (minusDays * 86400000));
  endDate.setHours(0,0,0,0);
  return endDate;
};

export const buildUniqueArrayFromField = (arr, keyField) => {
  const unique = arr
      .map(e => e[keyField])
      .filter((val,id,array) => array.indexOf(val) == id);

   return unique;
};

export const arrayToObject = (array, keyField) =>
  array.reduce((obj, item) => {
      obj[item[keyField]] = item;
      return obj;
  }, {});

export const getPretestType = (programID) =>{
    programID = programID.toLowerCase();
    if(programID == 'sw' || programID == 'w2' ||
       programID == 'cp' || programID == 'c2' || programID == 'c3' ||
       programID == 'l1' || programID == 'l2' ||
       programID == 'fw')
       return '|GRADED|';
    return '|RANDOM|';
};

export const escapeRegExp=(string)=>string.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1');
export const replaceAll=(string, find, replace) => string.replace(new RegExp(escapeRegExp(find), 'g'), replace);

export const uploadCSV = (fileName, csvString)=>{
  if(window.navigator.userAgent.indexOf('Edge') > -1){
      console.log('This feature is not supported in Edge Browsers.  Please use Chrome or Firefox');
  }
  else{
      let newLine = '%0A';
      let spaceCode= '%20';    
      let a         = document.createElement('a');
      a.href        = 'data:attachment/csv,' + replaceAll(csvString,' ',spaceCode);
      a.target      = '_blank';
      a.download    = fileName+'.csv';

      document.body.appendChild(a);
      a.click();
  }
};

export const differenceInDays = (firstDate, secondDate) => Math.round((secondDate-firstDate)/(1000*60*60*24))+1;

export const convertDictionaryKeys = (dic, newKey) => arrayToObject(toArray(dic), newKey);

export const aReduce   = fn => z => xs => xs.reduce(fn, z);
export const filter    = fn => xs => xs.filter(fn);
export const sort      = f => xs => xs.sort(f);
export const adjust    = n => f => xs => mapi(x => i => i === n ? f(x) : x)(xs);
export const dropFirst = xs => xs.slice(1);
export const dropLast  = xs => xs.slice(0, xs.length - 1);
export const id        = x => x;
export const k         = x => y => x;
export const map       = f => xs => xs.map(f);
export const mapi      = f => xs => xs.map((x, i) => f(x)(i));
export const merge     = o1 => o2 => Object.assign({}, o1, o2);
export const mod       = x => y => ((y % x) + x) % x; // http://bit.ly/2oF4mQ7
export const objOf     = k => v => ({ [k]: v });
export const pipe      = (...fns) => x => [...fns].reduce((acc, f) => f(acc), x);
export const prop      = k => o => o[k];
export const range     = min => max => [...Array(max).keys()].map((_, i) => i + min);
export const rep       = c => n => map(k(c))(range(0)(n));
export const rnd       = min => max => Math.floor(Math.random() * max) + min;
export const spec      = o => x => Object.keys(o)
  .map(k => objOf(k)(o[k](x)))
  .reduce((acc, o) => Object.assign(acc, o));
export const add = x => y => x + y;
export const transpose = xsxs => xsxs[0].map((col, i) => xsxs.map(row => row[i]));
export const mirror = xsxs => xsxs.map(xs => xs.reverse());
export const join = s => xs => xs.join(s);
export const concat = x1 => x2 => x1.concat(x2);
export const ifelse = c => t => f => x => c(x) ? t(x) : f(x);
export const reduce = f => z => xs => xs.reduce((acc, x) => f(acc)(x), z);
export const eq = x => y => x === y;
export const find = f => xs => xs.find(f);
export const append = x => xs => [...xs, x];
export const not = f => x => !f(x);
export const and = x => y => x && y;
export const or = x => y => x || y;
export const all = f => pipe(map(f), reduce(and)(true));
export const any = f => pipe(map(f), reduce(or)(false));
export const flip = f => x => y => f(y)(x);
export const gt = x => y => x > y;
export const lt = x => y => x < y;
export const both = f => g => x => f(x) && g(x);  